module.exports = __webpack_public_path__ + "static/media/23.8af12a71.gif";